module.exports = __webpack_public_path__ + "static/media/99_pub_logo.ecc8e09a.svg";